import type { EvidenceNumberType } from '../../types/evidence-numbers'

const TYPE_STYLES: Record<EvidenceNumberType, string> = {
  base: 'text-slate-900 dark:text-slate-100 hover:text-[var(--accent)]',
  collection_amendment:
    'text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300',
}

interface EvidenceNumberLinkProps {
  evidenceNumber: string
  numberType: EvidenceNumberType
  onClick?: () => void
  className?: string
}

export function EvidenceNumberLink({
  evidenceNumber,
  numberType,
  onClick,
  className = '',
}: EvidenceNumberLinkProps): React.ReactElement {
  const style = TYPE_STYLES[numberType]

  return (
    <button
      type="button"
      onClick={onClick}
      className={`font-mono text-sm font-medium underline-offset-2 hover:underline ${style} ${className}`}
    >
      {evidenceNumber}
    </button>
  )
}
